import { render, staticRenderFns } from "./LiveSalesDeveloperCampaigns.vue?vue&type=template&id=27828d8d&scoped=true"
import script from "./LiveSalesDeveloperCampaigns.vue?vue&type=script&lang=js"
export * from "./LiveSalesDeveloperCampaigns.vue?vue&type=script&lang=js"
import style0 from "./LiveSalesDeveloperCampaigns.vue?vue&type=style&index=0&id=27828d8d&prod&scoped=true&lang=css"
import style1 from "./LiveSalesDeveloperCampaigns.vue?vue&type=style&index=1&id=27828d8d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27828d8d",
  null
  
)

export default component.exports